import { computed } from "vue"
import type { Product } from "~/models/Product"

export function useProductPointOfSales() {
    const getPointOfSaleList = (product: Product) => {
        return product.point_of_sale_display.filter((i) => {
            return i.quantity > 0
        })
    }

    return getPointOfSaleList
}
